import { Fragment, memo } from 'react';
import AccordionGenerality from './generality';
import SubjectAttributes from './subject-attributes';
import BirthdayDocument from './birthday-document';
import Citizenship from './citizenship';
import Paternity from './paternity';
import Maternity from './maternity';

interface RegistryOfficeProps {
  isEdit?: boolean;
}

const RegistryOfficeComponent = ({}: RegistryOfficeProps): React.ReactElement => {
  return (
    <Fragment>
      <AccordionGenerality />
      <SubjectAttributes />
      <BirthdayDocument />
      <Citizenship />
      <Paternity />
      <Maternity />
    </Fragment>
  );
};

RegistryOfficeComponent.displayName = 'Registry Office step component';

const RegistryOffice = memo(RegistryOfficeComponent);

export default RegistryOffice;
